import React from 'react';
import { clsx } from 'clsx';

import { Modal, ModalProps } from '../Modal/Modal';
import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  TabsProps
} from '../Tabs/Tabs';

import styles from './ModalWithTabs.module.scss';

//
// ModalTabs
// --------------------
export type ModalTabsProps = TabsProps & {
  // TabsProps doesn't include this, but it does exist
  className?: string;
};
export const ModalTabs = ({
  className,
  children,
  ...otherProps
}: ModalTabsProps) => {
  return (
    <Tabs className={clsx(styles.tabs, className)} {...otherProps}>
      {children}
    </Tabs>
  );
};

//
// ModalTabList
// --------------------
export interface ModalTabListProps {
  children: React.ReactNode;
  className?: string;
}
export const ModalTabList = ({ className, children }: ModalTabListProps) => {
  return (
    <TabList className={clsx(styles.tabList, className)}>{children}</TabList>
  );
};

//
// ModalTab
// --------------------
export interface ModalTabProps {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
}
export const ModalTab = ({
  className,
  children,
  disabled = false
}: ModalTabProps) => {
  return (
    <Tab className={clsx(styles.tab, className)} disabled={disabled}>
      {children}
    </Tab>
  );
};

//
// ModalTabPanels
// --------------------
export interface ModalTabPanelsProps {
  children: React.ReactNode;
  className?: string;
}
export const ModalTabPanels = ({
  className,
  children
}: ModalTabPanelsProps) => {
  return (
    <TabPanels className={clsx(styles.tabPanels, className)}>
      {children}
    </TabPanels>
  );
};

//
// ModalTabPanels
// --------------------
export interface ModalTabPanelProps {
  children: React.ReactNode;
  className?: string;
}
export const ModalTabPanel = ({ className, children }: ModalTabPanelProps) => {
  return (
    <TabPanel className={clsx(styles.tabPanel, className)}>{children}</TabPanel>
  );
};

//
// ModalWithTabs
// --------------------
export type ModalWithTabsProps = ModalProps & {
  logo?: string;
};
export const ModalWithTabs = ({
  isOpen,
  className,
  onDismiss,
  children,
  title,
  logo,
  ...props
}: ModalWithTabsProps) => {
  return (
    <Modal
      isOpen={isOpen}
      className={clsx(styles.dialog, className)}
      onDismiss={onDismiss}
      hasClose={true}
      {...props}
    >
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <h2 className={styles.headerTitle}>
            {logo && <img src={logo} alt="" className={styles.logo} />}
            {title}
          </h2>
        </div>
      </div>
      {children}
    </Modal>
  );
};
